// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  color: #ac988d;
}

video {
  margin-left: auto;
  margin-right: auto;
  display: block;
}

swiper {
  padding-bottom: 50px;
  margin-bottom: 20px;
  border: none;
}
swiper .slide {
  display: block;
}
swiper .slide h2 {
  color: #cc8c57;
  margin-top: 4vh;
  font-weight: 900;
  font-size: 21px;
  text-align: center;
}
swiper .slide img {
  width: 60%;
  height: 300px;
  margin: auto auto;
  display: block;
  object-fit: contain;
}
swiper .slide .plane {
  width: 100%;
}
swiper .slide p {
  padding: 0 20px;
  font-size: 12px;
  line-height: 1.5;
  color: #d2b094;
  max-width: 85%;
  margin-left: auto;
  margin-right: auto;
}
swiper .slide p b {
  font-weight: bold;
  color: #e29351;
}

.inital_menu {
  margin-top: 10%;
}

ion-button {
  width: 70%;
  height: 45px;
  font-weight: bold;
  margin: 10px 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
ion-button ion-label {
  width: 70%;
}

.homeImg {
  margin: 0;
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 150px;
  box-shadow: 0px 1px 13px #bca599;
  margin-top: 10px;
  border-radius: 10px;
}

h1,
p {
  color: #ac988d;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 60%;
}`, "",{"version":3,"sources":["webpack://./src/app/howto-delivery/howto-delivery.page.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;;AAEA;EACI,iBAAA;EACA,kBAAA;EACA,cAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;AACJ;AACI;EACI,cAAA;AACR;AACQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AACZ;AAEQ;EACI,UAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAAZ;AAGQ;EACI,WAAA;AADZ;AAIQ;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAEA,cAAA;EACA,iBAAA;EACA,kBAAA;AAHZ;AAMQ;EACI,iBAAA;EACA,cAAA;AAJZ;;AASA;EACI,eAAA;AANJ;;AASA;EACI,UAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EAEA,cAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;AASI;EACI,UAAA;AAPR;;AAWA;EACI,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,mBAAA;AARJ;;AAWA;;EAEI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AARJ","sourcesContent":["ion-toolbar {\n    color: #ac988d;\n}\n\nvideo {\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n}\n\nswiper {\n    padding-bottom: 50px;\n    margin-bottom: 20px;\n    border: none;\n\n    .slide {\n        display: block;\n\n        h2 {\n            color: #cc8c57;\n            margin-top: 4vh;\n            font-weight: 900;\n            font-size: 21px;\n            text-align: center;\n        }\n\n        img {\n            width: 60%;\n            height: 300px;\n            margin: auto auto;\n            display: block;\n            object-fit: contain;\n        }\n\n        .plane {\n            width: 100%;\n        }\n\n        p {\n            padding: 0 20px;\n            font-size: 12px;\n            line-height: 1.5;\n            color: #d2b094;\n\n            max-width: 85%;\n            margin-left: auto;\n            margin-right: auto;\n        }\n\n        p b {\n            font-weight: bold;\n            color: #e29351;\n        }\n    }\n}\n\n.inital_menu {\n    margin-top: 10%;\n}\n\nion-button {\n    width: 70%;\n    height: 45px;\n    font-weight: bold;\n    margin: 10px 0;\n\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    ion-label {\n        width: 70%;\n    }\n}\n\n.homeImg {\n    margin: 0;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n    width: 150px;\n    box-shadow: 0px 1px 13px #bca599;\n    margin-top: 10px;\n    border-radius: 10px;\n}\n\nh1,\np {\n    color: #ac988d;\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n    width: 60%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
